<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="co_title"
      placeholder="输入标题进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/contract/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.co_title}}</p>
          <p class="list-item-muted">{{item.co_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p></p>
          <span
            class="list-item-status"
            :class="{'warning':item.co_status!='已审核'}"
          >{{item.co_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}份</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/contract/list",
      filters: [
        {
          type: "date",
          name: "co_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "co_statuscode!='AUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "co_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>